import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import Title from "../../components/Title";
import SubMenu from "../../components/SubMenu";
import { analyticsMenuOptions, isTabWidth } from "../../data/database";

const AnalyticsHome = () => {
  const isTab = useMediaQuery(isTabWidth);
  return (
    <>
      <Box
        sx={{
          backgroundColor: "#ebecf0",
        }}
      >
        <Box sx={{ backgroundColor: "#ebecf0", height: isTab ? 90 : 130 }} />
        <Box
          sx={{
            backgroundColor: "#ebecf0",
            width: "100%",
            margin: "0 auto",
          }}
        >
          <Title title="Data Dashboard" fontSize={isTab ? "1.25rem" : "2rem"} />
        </Box>
        <Box sx={{ width: "95%", maxWidth: "1200px", margin: "0.75rem auto" }}>
          <SubMenu
            menuOptions={analyticsMenuOptions}
            padding={isTab ? "0.5rem 1rem" : "1rem 2rem"}
            fontSize={isTab ? "0.8rem" : "1rem"}
          />
        </Box>
        <Box
          sx={{
            backgroundColor: "#ebecf0",
            width: "100%",
            height: "100dvh",
          }}
        />
      </Box>
    </>
  );
};

export default AnalyticsHome;
